import { render, staticRenderFns } from "./SubmissionFormStep2.vue?vue&type=template&id=6c28a2ac&scoped=true&"
import script from "./SubmissionFormStep2.vue?vue&type=script&lang=js&"
export * from "./SubmissionFormStep2.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./SubmissionFormStep2.vue?vue&type=style&index=1&lang=css&"
import style2 from "./SubmissionFormStep2.vue?vue&type=style&index=2&id=6c28a2ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c28a2ac",
  null
  
)

export default component.exports